import { gallery } from './modules/gallery';
import { lodashAction } from './modules/lodashAction';
import { modal } from './modules/modalMovie';
const { pageTop } = require('./modules/pageTop');
const { scrollmagic } = require('./modules/scrollmagic');
const { smooth } = require('./modules/smooth');

gallery();
lodashAction();
modal();
pageTop();
scrollmagic();
smooth();
